import { createStyles, UnstyledButton, useMantineTheme, Tooltip } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import React from 'react';

// Custom styles
const useStyles = createStyles((theme) => ({
	button: {
		marginTop: 6
	},
}));

const DeleteButton = ({ onClick, disabled }) => {

	// State and hooks
	const { classes } = useStyles();
	const theme = useMantineTheme();

	return (
		<Tooltip
			label="Eliminar"
			withArrow
			disabled={disabled}
		>
			{/* Button */}
			<UnstyledButton
				disabled={disabled}
				onClick={onClick}
				className={classes.button}
				sx={{
					cursor: disabled ? 'not-allowed' : 'pointer'
				}}
			>
				{/* Icon */}
				<IconTrash
					color={theme.colors.red[9]}
					stroke={2}
					size={20}
					opacity={disabled ? 0.2 : 1}
				/>
			</UnstyledButton>
		</Tooltip>
	);

}

export default DeleteButton;
